import { Box } from '@chakra-ui/react';
import cx from 'clsx';

import styles from './BlogPost.module.css';

/** Article typography is shared with Editor.js; Quill classes retain historic alignment/indents. */
export const LegacyBlogContent = ({ html }: { html: string }) => (
  <Box
    className={cx(styles.content, 'ql-editor')}
    textStyle="article.body"
    color="fg"
    css={{
      '&&': { textStyle: 'article.body' },
      '&& h1': { textStyle: 'article.h1', mt: 10, mb: 4 },
      '&& h2': { textStyle: 'article.h2', mt: 12, mb: 4 },
      '&& h3': { textStyle: 'article.h3', mt: 8, mb: 4 },
      '&& h4, && h5, && h6': { textStyle: 'article.h4', mt: 6, mb: 4 },
      '&& p': { mb: 6 },
      '&& ul, && ol': { mb: 6 },
      '&& li + li': { mt: 2.5 },
      '&& li::marker, && li > .ql-ui::before': { color: 'purple.fg' },
      '&& li p, && li ul, && li ol': { mb: 0 },
      '& a[href]': { color: 'purple.fg', textDecoration: 'underline', textUnderlineOffset: '3px' },
      '& a[href]:hover': { textDecorationThickness: '2px' },
    }}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);
